module.exports = __webpack_public_path__ + "img/logo-white.d6f303c4.png";